import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  Button,
  Cascader,
  Row,
  message,
  InputNumber,
} from "antd";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import RoleApi from "@api/role";
import sysApi from "@api/sys";
import stationApi from "@api/station";
import AddModal from "@components/Modal";
import InspectionApi from "@api/inspectionnew";
import { findAllParents } from "../../../utils/common";

import "../style.scss";
import "./index.scss";

// 周期标签组件：当单位选择"个月"时，标签显示"周期第"
const PeriodLabel = ({ namePath, form }) => {
  const unit = Form.useWatch(namePath, form);
  return unit === "个月" ? "周期第" : "周期";
};

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
};
const Option = Select.Option;

export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [deviceLs, setDeviceLs] = useState([]);
  const [tmpLs, setTmpLs] = useState([]);
  const [roleLs, setRoleLs] = useState(); // 角色列表
  useEffect(() => {
    // 获取当前厂站的id
    if (formData) {
      form.setFieldsValue({
        ...formData,
		upkeepTemplateType: 1,
		stationId: formData.stationId?String(formData.stationId):''
      });
      changStation(formData.stationId, "first");
    }
    // 查询角色列表
    RoleApi.query({ pageNum: 1, pageSize: 10000 }).then((res) => {
      if (res.status !== "0") return;
      setRoleLs(res.data.data);
    });
    // 获取模板列表
    InspectionApi.upkeepTemplate({ pageNum: 1, pageSize: 100000 }).then(
      (res) => {
        if (res.status !== "0") return;
        const ls = res.data.data.filter((item) => item.status === 1);
        setTmpLs(ls);
      }
    );
	changeTmpType(1)
  }, []);

  const changStation = (e, type = "station") => {
    stationApi.getDeviceByStationId({ stationId: e }).then((res) => {
      if (res.status !== "0") return;
      const upkeepStandardTemplateAddDTOList = [
        ...formData.upkeepStandardTemplateAddDTOList,
      ];
      if (type == "first") {
        upkeepStandardTemplateAddDTOList.forEach((item) => {
          item.deviceId = findAllParents(res.data, item.deviceId, [], "number");
        });
      } else {
        upkeepStandardTemplateAddDTOList.forEach((item) => {
          item.deviceId = [];
        });
      }
      setDeviceLs(res.data);
      form.setFieldsValue({
        upkeepStandardTemplateAddDTOList,
      });
    });
  };

  const getChild = (arr) => {
    const role = form.getFieldValue("handleRole");
    return arr.map((item) => {
      if (item.children && item.children.length > 0) {
        item.children = getChild(item.children);
        if (role != "area_manager") {
          item.disabled = item.deviceId ? false : true;
        }
        return item;
      } else {
        delete item.children;
        if (role != "area_manager") {
          item.disabled = item.deviceId ? false : true;
        }
        return item;
      }
    });
  };

  // 添加保养项
  const addUpkeepContent = (index) => {
    const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
    params[index].upkeepStandardItemAddDTOList.push({
      grease: null,
      itemContent: null,
      oilMass: null,
      period: 1,
      unit: "个周",
      upkeepTime: null,
    });
    form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
  };

  const changeUpTmp = (index, e) => {
    InspectionApi.upkeepTemplateGetInfo(e).then((res) => {
      if (res.status !== "0") return;
      res.data.upkeepTemplateItemDTOList.map(
        (item) => (item.unit = item.period.substring(item.period.length - 2))
      );
      res.data.upkeepTemplateItemDTOList.map(
        (item) =>
          (item.period = item.period.substring(0, item.period.length - 2))
      );
      const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
      params[index].upkeepStandardItemAddDTOList =
        res.data.upkeepTemplateItemDTOList;
      form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
    });
  };

  // 移除保养项
  const removeUpkeepContent = (index, subIndex) => {
    const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
    params[index].upkeepStandardItemAddDTOList.splice(subIndex, 1);
    form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
  };

  // 添加保养标准
  const addUpkeepStandard = () => {
    const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
    params.push({
      deviceId: null,
      upkeepStandardItemAddDTOList: [
        {
          grease: null,
          itemContent: null,
          oilMass: null,
          period: 1,
          unit: "个周",
          upkeepTime: null,
        },
      ],
      upkeepTemplateId: null,
    });
    form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
  };

  // 移除保养标准
  const removeUpkeepStandard = (index) => {
    const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
    params.splice(index, 1);
    form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
  };

  // 切换保养模板类型
  const changeTmpType = (value) => {
    const params = form.getFieldValue("upkeepStandardTemplateAddDTOList");
    params[0].upkeepTemplateId = null;
    form.setFieldsValue({ upkeepStandardTemplateAddDTOList: params });
    InspectionApi.upkeepFlagTemplate({ id: value }).then((res) => {
      if (res.status !== "0") return;
      setTmpLs([...res.data]);
    });
  };

  // 提交
  const submit = () => {
    form.validateFields().then(async (values) => {
      if (!values) {
        return;
      }
      setLoading(true);

      const params = JSON.parse(JSON.stringify(values));
      params.upkeepStandardTemplateAddDTOList.map((item) => {
        item.deviceId = item.deviceId[item.deviceId.length - 1];
        item.upkeepStandardItemAddDTOList.map((subItem) => {
          subItem.period = subItem.period + subItem.unit;
        });
      });

      if (formData && formData.id) {
        // 获取流程id
        const result = await sysApi.getFlowableId({
          dictType: "sw-flowable",
          dictKey: "upkeep_standard_updateInfo",
        });
        if (result.status !== "0") return;
        const processId = result.data;
        InspectionApi.upkeepStandardUpdateInfo(
          { ...params, id: formData.id },
          processId
        ).then((res) => {
          if (res.status == 0) {
            message.success("修改成功");
            handelCancel(true);
          }
          setLoading(false);
        });
      } else {
        InspectionApi.upkeepStandardAdd(params)
          .then(async (res) => {
            if (res.status == 0) {
              const process = await sysApi.getFlowableId({
                dictType: "sw-flowable",
                dictKey: "upkeep_standard_status_enable",
              });
              if (process.status !== "0") return;
              const processId = process.data;
              const result = await InspectionApi.upkeepStandardEnable({
                id: res.data,
                processId,
              });
              if (result.status !== "0") return;
              message.success("添加成功");
              handelCancel(true);
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    });
  };
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  };
  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button key={1} onClick={handelCancel} className="abuttons">
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          <Button
            key={2}
            loading={loading}
            onClick={submit}
            className="abuttons"
            type="primary"
          >
            <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
          </Button>
        </Row>,
      ]}
      visible={visible}
      width={800}
      okText={"确定"}
      onCancel={handelCancel}
      onSubmit={() => submit()}
    >
      <div className="upkeep-standard-modal">
        <Form {...layout} form={form}>
          <Form.Item
            label="厂站"
            name="stationId"
            rules={[{ required: true, message: "请选择厂站" }]}
          >
            <Select placeholder="请选择厂站" onChange={changStation}>
              {stationData &&
                stationData.map((item) => (
                  <Option value={item.value} key={item.value}>
                    {item.title}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="名称"
            name="upkeepStandardName"
            rules={[{ required: true, message: "请输入保养名称" }]}
          >
            <Input row={4} placeholder={"请输入保养名称"} />
          </Form.Item>
          <Form.Item
            label="角色"
            name="handleRoleId"
            rules={[{ required: true, message: "请选择角色" }]}
          >
            <Select placeholder="请选择">
              {roleLs &&
                roleLs.map((item) => {
                  return (
                    <Select.Option value={item.id - 0} key={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            label="保养模板类型"
            name="upkeepTemplateType"
            rules={[{ required: true, message: "请选择保养模板类型" }]}
          >
            <Select disabled placeholder="保养模板类型" onChange={changeTmpType}>
              <Option value={0}>设备人员模板</Option>
              <Option value={1}>操作人员模板</Option>
            </Select>
          </Form.Item>
          <Form.List name="upkeepStandardTemplateAddDTOList">
            {(fields) => {
              return (
                <>
                  {fields.map((field, index) => (
                    <div key={field.key} className="upkeep-standard-ls">
                      <Form.Item
                        label="保养设备"
                        name={[field.name, "deviceId"]}
                        rules={[{ required: true, message: "请选择保养设备" }]}
                      >
                        <Cascader
                          fieldNames={{
                            label: "itemName",
                            value: "id",
                            children: "child",
                          }}
                          options={deviceLs}
                          placeholder="请选择设备"
                        />
                      </Form.Item>
                      <Form.Item
                        label="保养模板"
                        name={[field.name, "upkeepTemplateId"]}
                        rules={[{ required: true, message: "请选择保养模板" }]}
                      >
                        <Select
                          onChange={(e) => {
                            changeUpTmp(index, e);
                          }}
                          placeholder="保养模板"
                        >
                          {tmpLs &&
                            tmpLs.map((item) => {
                              return (
                                <Option value={item.id + ""} key={item.id}>
                                  {item.templateName}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                      <Form.List
                        name={[field.name, "upkeepStandardItemAddDTOList"]}
                      >
                        {(subFields, { add, remove }) => {
                          return (
                            <>
                              {subFields.map((subField, subIndex) => (
                                <div
                                  key={subField.key}
                                  className="upkeep-standard-ls"
                                >
                                  <Form.Item
                                    name={[subField.name, "itemContent"]}
                                    label="保养内容"
                                    rules={[
                                      {
                                        required: true,
                                        message: "请输入保养内容",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="请输入保养内容" />
                                  </Form.Item>
                                  <Form.Item
                                    name={[subField.name, "grease"]}
                                    label="油脂"
                                    rules={[
                                      { required: true, message: "请输入油脂" },
                                    ]}
                                  >
                                    <Input placeholder="请输入油脂" />
                                  </Form.Item>
                                  <Form.Item
                                    name={[subField.name, "oilMass"]}
                                    label="油量"
                                    rules={[
                                      { required: true, message: "请输入油量" },
                                    ]}
                                  >
                                    <Input placeholder="请输入油量" />
                                  </Form.Item>
                                  <div className="upkeep-period">
                                    <Form.Item
                                      name={[subField.name, "period"]}
                                      label={
                                        <PeriodLabel
                                          namePath={[
                                            "upkeepStandardTemplateAddDTOList",
                                            field.name,
                                            "upkeepStandardItemAddDTOList",
                                            subField.name,
                                            "unit",
                                          ]}
                                          form={form}
                                        />
                                      }
                                      rules={[
                                        {
                                          required: true,
                                          message: "请输入周期",
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        className="upkeep-period-ipt"
                                        min={1}
                                        max={12}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      name={[subField.name, "unit"]}
                                      className="upkeep-unis"
                                    >
                                      <Select>
                                        <Option value="个周">个周</Option>
                                        <Option value="个月">个月</Option>
                                      </Select>
                                    </Form.Item>
                                  </div>
                                  {subFields.length > 1 && (
                                    <MinusCircleOutlined
                                      onClick={() => {
                                        removeUpkeepContent(index, subIndex);
                                      }}
                                      style={{
                                        marginLeft: "15px",
                                        margin: "10px,0",
                                      }}
                                    />
                                  )}
                                </div>
                              ))}
                              <div className="form-ls-add">
                                <PlusCircleOutlined
                                  onClick={() => addUpkeepContent(index)}
                                />
                              </div>
                            </>
                          );
                        }}
                      </Form.List>
                      {fields.length > 1 && (
                        <MinusCircleOutlined
                          onClick={() => {
                            removeUpkeepStandard(index);
                          }}
                          style={{ marginLeft: "15px", margin: "10px,0" }}
                        />
                      )}
                    </div>
                  ))}
                  <div className="form-ls-add">
                    {/* <Button type='primary' size='mini' onClick={ () => addUpkeepStandard() }>添加保养标准模板</Button> */}
                  </div>
                </>
              );
            }}
          </Form.List>
        </Form>
      </div>
    </AddModal>
  );
};
